import { NAME } from './constants';

export const getSession = state => state[NAME];
export const getComponentState = (state, componentName) => (
  state[NAME] &&
  state[NAME].componentStates &&
  state[NAME].componentStates[componentName]
);
